var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderShortcuts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.31,
    y: 2.98,
    width: 26,
    height: 26,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.31,4V28h-24V4h24m2-2h-28V30h28V2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "21.31 7.98 7.31 7.98 11.81 12.48 5.31 18.98 10.31 23.98 16.81 17.48 21.31 21.98 21.31 7.98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderShortcuts);
export default __webpack_public_path__ + "static/media/folder-shortcuts.4b98cd52.svg";
export { ForwardRef as ReactComponent };